import { getFirestore } from 'firebase/firestore';
import type { Firestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import type { FirebaseStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import type { Functions } from 'firebase/functions';
import * as firebaseApp from 'firebase/app';

// Fix: Namespace import for auth to bypass resolution issues
import * as firebaseAuth from 'firebase/auth';
const authModule = firebaseAuth as any;
const getAuth = authModule.getAuth;
const GoogleAuthProvider = authModule.GoogleAuthProvider;
// Define Auth type as any to avoid 'no exported member' error
type Auth = any;

// ------------------------------------------------------------------
// FIREBASE CONFIGURATION (Modular / v9 Syntax)
// ------------------------------------------------------------------

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAwjhsWhtpHPAFFB4xezaB3NDUtfYCuxcw",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "ikigai-lab.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "ikigai-lab",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "ikigai-lab.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "668931655456",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:668931655456:web:6c194835c03dfb6b7ef945",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-F91K6WC5E2"
};

// ------------------------------------------------------------------

// Validation check to see if keys are present
const isConfigured = firebaseConfig.apiKey &&
  !firebaseConfig.apiKey.includes("PASTE_YOUR_API_KEY_HERE");

let app: any | undefined;
let auth: Auth | null = null;
let db: Firestore | null = null;
let storage: FirebaseStorage | null = null;
let functions: Functions | null = null;
let googleProvider: any | null = null;

if (isConfigured) {
  try {
    // Initialize Firebase (Check if already initialized for hot-reload)
    // Use namespace import access to avoid named export resolution issues in some environments
    const fb = firebaseApp as any;

    // Robustly resolve functions from namespace or default export
    const getApps = fb.getApps || (fb.default && fb.default.getApps);
    const initializeApp = fb.initializeApp || (fb.default && fb.default.initializeApp);
    const getApp = fb.getApp || (fb.default && fb.default.getApp);

    const apps = getApps ? getApps() : [];

    if (!apps.length) {
      if (initializeApp) {
        app = initializeApp(firebaseConfig);
      }
    } else {
      app = getApp ? getApp() : apps[0];
    }

    if (app) {
      auth = getAuth(app);
      db = getFirestore(app);
      storage = getStorage(app);

      // CRITICAL: Must match Backend Region (asia-southeast1).
      // If mismatched, calls default to 'us-central1' and fail (404).
      functions = getFunctions(app, 'asia-southeast1');

      googleProvider = new GoogleAuthProvider();
      console.log("✅ Firebase initialized successfully (Modular v9) with project:", firebaseConfig.projectId);
    }
  } catch (error) {
    console.error("❌ Firebase initialization failed:", error);
  }
} else {
  console.warn("⚠️ Firebase is NOT configured. App is running in Mock Mode.");
}

export { app, auth, db, storage, functions, googleProvider, isConfigured };